import { Settings, Link2, Database, BookUser, Cctv, Search, LockOpen } from 'lucide-react'; 
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';
import { useTheme } from '@/components/theme/ThemeProvider';
import { useNavigation } from '@/hooks/useNavigation';
import ContactSupport from '@/components/support/ContactSupport';
import logoLight from '@/img/Logo.svg';
import logoDark from '@/img/LogoDark.svg';

const navigation = [
  { name: 'AI Threat Profile', href: '/', icon: BookUser, enabled: true }, // Moved to top and changed href
  { name: 'Threat Search', href: '/threat-intelligence', icon: Search, enabled: true },
  { name: 'Dark Web Intelligence', href: '/dark-web', icon: LockOpen, enabled: true },
  { name: 'Ransomware Monitor', href: '/ransomware', icon: Cctv, enabled: true },
  { name: 'Vulnerability Management', href: '/vulnerabilities', icon: Database, enabled: true },
  { name: 'Integrations', href: '/integrations', icon: Link2, enabled: true },
  { name: 'Settings', href: '/settings', icon: Settings, enabled: true },
];

interface SidebarProps {
  onNavigate?: () => void;
}

export function Sidebar({ onNavigate }: SidebarProps) {
  const { theme } = useTheme();
  const { currentPath, handleNavigation } = useNavigation(onNavigate);

  return (
    <div className="flex h-full w-64 flex-col border-r border-border bg-card/80 backdrop-blur-sm relative">
      <Link to="/" className="flex h-16 items-center gap-2 border-b border-border px-6">
        <div className="mr-2 flex h-7 w-8 items-center">
          <img 
            src={theme === 'dark' ? logoDark : logoLight} 
            alt="Logo" 
            className="h-full w-full"
          />
        </div>
        <span className="font-ibm-condensed text-2xl text-foreground">
          Pax Intelligence
        </span>
      </Link>
      <nav className="flex-1 space-y-1 px-3 py-6">
        {navigation.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            onClick={(e) => handleNavigation(e, item)}
            className={cn(
              'group flex items-center rounded-md px-3 py-2.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground',
              currentPath === item.href && 'bg-accent text-accent-foreground',
              !item.enabled && 'opacity-60'
            )}
          >
            <item.icon
              className={cn(
                'mr-3 h-5 w-5 flex-shrink-0',
                currentPath === item.href
                  ? 'text-accent-foreground'
                  : 'text-muted-foreground group-hover:text-accent-foreground'
              )}
              aria-hidden="true"
            />
            <span className="flex-1">{item.name}</span>
            {!item.enabled && (
              <span className="ml-2 rounded-full bg-primary/10 px-2 py-0.5 text-xs text-primary">
                Soon
              </span>
            )}
          </Link>
        ))}
        
        {/* Contact Support - Added at the bottom of navigation */}
        <div className="absolute bottom-6 left-3 right-3 ml-[1%]">
          <ContactSupport />
        </div>
      </nav>
    </div>
  );
}